export default "__VITE_PUBLIC_ASSET__c4ff0bcc__"